module.exports = __webpack_public_path__ + "img/funeral.0c5a626f.png";